function checkDevice() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) {
      return true;
  }

  if (/android/i.test(userAgent)) {
      return true;
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return true;
  }

  return false;
}


function setCarouselSize(scrollY = 0, scrollYLimit = 0) {
  if (checkDevice())
    return;
    
  const wW = parseInt(jQuery(window).width()),
        wH = parseInt(jQuery(window).height());

  let space = parseInt(jQuery('.image_option').css('gap').match(/\d+/g)[0]),
      containerMaxWidth = parseInt(jQuery('.product-container').css("max-width").match(/\d+/g)[0]),
      optionMinWidth = parseInt(jQuery('.variant_option').css('min-width').match(/\d+/g)[0]),
      stickyBarHeight = parseInt(jQuery(".product__sticky-bar-wrapper").height()) > 94 ? 94 : parseInt(jQuery(".product__sticky-bar-wrapper").height()),
      optionWidth = parseInt(jQuery('.variant_option').width()),
      
      tWidth = wW > containerMaxWidth ? containerMaxWidth : wW,
      xPadding = !checkDevice() ? 50 : 32;

  var width = tWidth - (optionWidth + xPadding * 2 + space),
      height = wH - stickyBarHeight - space * 2;

  height = height > 1200 ? 1200 : height;
  if (width != height) {
    possibleWidth = tWidth - xPadding * 2 - space - optionMinWidth;
    if (possibleWidth > height) {
      width = height;
      optionWidth = tWidth - height - xPadding * 2 - space;
    } else {
      height = possibleWidth;
      width = possibleWidth;
      optionWidth = optionMinWidth;
    }
    jQuery('.variant_option').width(optionWidth);
  } 
  
  jQuery('.contain').width(width).css('position', 'sticky');
  jQuery('.owl-carousel').width(width).height(height).trigger('refresh.owl.carousel');

  jQuery('.variant_option > .variant-wrapper').css('padding-top', parseInt(jQuery('.contain').height() / 2) + 'px');
  jQuery('.variant_option > .variant-wrapper').css('padding-bottom', parseInt(height / 2 - jQuery('.giftBox_wrp').height() - 50) + 'px');
  jQuery('.giftBox_wrp').css('margin-bottom', parseInt((jQuery('.contain').height() - height) / 2) + 'px');
}

jQuery(document).ready(function () {

  if (jQuery(window).width() > 965){
  
  const scrollYLimit = document.querySelector('.product-info_text').offsetTop + document.querySelector('.product-info_text').clientHeight;
  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > scrollYLimit) {
      if (!document.querySelector(".product__sticky-bar-wrapper").classList.contains('sticky-bar-visible'))
        document.querySelector(".product__sticky-bar-wrapper").classList.add('sticky-bar-visible');
    } else {
      if (document.querySelector(".product__sticky-bar-wrapper").classList.contains('sticky-bar-visible'))
        document.querySelector(".product__sticky-bar-wrapper").classList.remove('sticky-bar-visible');
    }
    setCarouselSize(jQuery(this).scrollTop() , scrollYLimit);
  });
  setCarouselSize();
  
  jQuery(window).resize(function() {
    setCarouselSize();
  });
  }

  // Function to update the span content based on the selected input
  function updateProductTitle() {
    var labelText = jQuery(".data_fatch_input:checked").attr("id");
    var label_html = jQuery("label[for=" + labelText + "]")
      .find(".data_fatch_tobe")
      .html();
    jQuery("span.fatch_product_title").html(jQuery.trim(label_html));
    var combinedValues = [];

    jQuery("variant-radios .js.product-form__input input:checked").each(function () {
      combinedValues.push(jQuery(this).val());
    });

    var result = combinedValues.join(" / ");

    jQuery(".all_variantPrice input").each(function () {
      var input_val = jQuery(this).val();
      if (result == input_val) {
        jQuery("span.product_instock strong").text(jQuery(this).attr("variant_avail"));
      }
    });

    var price_var = jQuery("label[for=" + labelText + "]")
      .find(".variant--price")
      .text();
    jQuery(".fatch_product_price").text(jQuery.trim(price_var));
    
  }

  // Call the function when the document is ready
  updateProductTitle();

  // Bind the function to the change event of the input
  jQuery(".data_fatch_input").on("change", function () {
    updateProductTitle();
  });
  jQuery(".data_fatch_input").on("click", function () {
    updateProductTitle();
  });

  jQuery("#variant-wrapper-3 input").on("change", function () {
    var uplaod = jQuery("div#variant-wrapper-3 input:checked").attr("data-upload");
    jQuery(".product_media-upload").text(uplaod);
  });
  jQuery('body').on( 'click','.tab-link',function() {	
        var tabID = jQuery(this).attr('data-tab');	
        jQuery(this).addClass('active').siblings().removeClass('active');
        jQuery('#tab-'+tabID).addClass('active').siblings().removeClass('active');
    });

  //remove border from hidden options
  remove_border_from_color_opt()
});

// For add active class to option swatches and other changes
jQuery(document).on("click",".option-value-wrapper",function() {
  jQuery('.option-value-wrapper').removeClass('active');
  jQuery(this).addClass('active');

  //update color name on change of color
  var variant_color_get = jQuery(this).find("input[name='Style']").val();
  if(variant_color_get != ""){
    jQuery(this).parents(".color-picker").find(".opt-title").html(variant_color_get);
  }

  //update theme title on change of theme option
  var variant_theme_get = jQuery(this).find("input[name='Theme']").val();
  if(variant_theme_get != ""){
    jQuery(this).parents(".theme-picker").find(".opt-title").html(variant_theme_get);
  }
  
  //update add to cart price text
  var variant_price_check = jQuery(this).find(".variant--price");
  if(variant_price_check.length > 0){
    var current_variant_price = variant_price_check.html();
    jQuery(".current-ammount").html(current_variant_price);
  }

  //remove border from hidden options
  setTimeout(function(){ 
    remove_border_from_color_opt();
  }, 5);
  
});


// For read more/less
jQuery('.readmore').click(function (event) {
  event.preventDefault();
  jQuery(".product-desc-full").slideDown();
  jQuery(".product-desc-short").hide();
});
jQuery('.readless').click(function (event) {
  event.preventDefault();
  jQuery(".product-desc-full").hide();
  jQuery(".product-desc-short").slideDown();
});

function remove_border_from_color_opt(){
  jQuery("input[name='Style']").each(function() {
    if(jQuery(this).hasClass("disabled")){
      jQuery(this).closest(".option-block").hide();
    }else{
      jQuery(this).closest(".option-block").show();
    }
  });
}
// Magnific popup
  
  // Caption Video/Audio: https://codepen.io/dimsemenov/pen/zjtbr
  $('.product-video-section').magnificPopup({
  type: 'iframe',
  
  iframe: {
      markup: '<div class="mfp-iframe-scaler">'+
                  '<div class="mfp-close"></div>'+
                  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
              '</div>'
  },
  callbacks: {
      markupParse: function(template, values, item) {
      values.title = item.el.attr('title');
      }
  }

  });
